import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import { loadThemeLocal, applyTheme, fetchAndApplyTheme } from './utils/theme';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Apply cached theme instantly to avoid FOUC, then fetch from backend
try {
  const { theme, palette } = loadThemeLocal();
  applyTheme(theme, palette);
} catch {}

// Fetch and apply latest theme (non-blocking)
fetchAndApplyTheme();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
